/* VidMax docs: the pinned links from brain/vidmax/index.html as rows (j/k to pick, o or Enter opens on GitHub). */
import { EDensity, EVerdict } from "../homeDashboard.types"
import type { IWidgetDefinition, IWidgetResult } from "../homeDashboard.types"
import { REPO_BLOB } from "./WidgetParts"

const BRAIN = "brain/vidmax"

const DOCS: { group: string; label: string; path: string }[] = [
  { group: "Plan", label: "Bets", path: "plan/bets.md" },
  { group: "Plan", label: "Decisions", path: "plan/decisions.md" },
  { group: "Plan", label: "Learnings", path: "plan/learnings.md" },
  { group: "Product", label: "Feature catalog", path: "features/CLAUDE.md" },
  { group: "Product", label: "VidMax router (query paths, systems)", path: "CLAUDE.md" },
  { group: "Design", label: "Design library", path: "design/index.html" },
  { group: "Design", label: "Visual context", path: "design/visual-context.md" },
  { group: "Eng", label: "System atlas", path: "architecture/system-atlas.md" },
  { group: "Eng", label: "Where new work goes", path: "architecture/where-new-work-goes.md" },
  { group: "Eng", label: "AI Software Factory", path: "architecture/ai-software-factory.html" },
  { group: "Eng", label: "Critical flows", path: "architecture/critical-flows.yaml" },
]

const DOCS_RESULT: IWidgetResult = {
  verdict: EVerdict.CLEAR,
  count: `${DOCS.length} pinned`,
  rows: DOCS.map((doc) => ({
    key: doc.path,
    verdict: EVerdict.CLEAR,
    pill: { text: doc.group, verdict: EVerdict.UNKNOWN },
    title: doc.label,
    sub: doc.path,
    href: `${REPO_BLOB}/${BRAIN}/${doc.path}`,
    hrefLabel: "Open on GitHub",
  })),
  ordered: true,
  empty: "",
}

export const docsWidget: IWidgetDefinition = {
  id: "docs",
  title: "VidMax docs",
  description: "Pinned brain/vidmax docs",
  columns: { 2: 1, 3: 1, 4: 4, 5: 5, 6: 6 },
  link: { href: `${REPO_BLOB}/${BRAIN}`, label: "Browse brain/vidmax" },
  companies: ["vidmax"],
  defaultDensity: EDensity.COMPACT,
  useWidget: () => ({ result: DOCS_RESULT, isLoading: false, isFetching: false, refetch: () => undefined }),
}
